import React, { useState } from 'react';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import { Delete, Edit } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Checkbox,
} from '@material-ui/core';
import { deleteParameter } from './areaParametersServices';
import EditAreaParameter from './EditAreaParameter';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

function AreaParameterTable({ areaParameters, deleteAreaParam }) {
  const [isModalOpen, toggleModal] = useState(false);
  const [parameterToEdit, setParameterToEdit] = useState(null);
  const classes = useStyles();

  const editParameter = (areaParameter) => {
    setParameterToEdit(areaParameter);
    toggleModal(true);
  };

  return (
    <React.Fragment>
      {isModalOpen ? (
        <EditAreaParameter
          isModalOpen={isModalOpen}
          toggleModal={toggleModal}
          parameterToEdit={parameterToEdit}
          setParameterToEdit={setParameterToEdit}
        />
      ) : null}
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Serial number</TableCell>
              <TableCell align="left">Name</TableCell>
              <TableCell align="left">Importance</TableCell>
              <TableCell align="left">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {areaParameters.map((areaParameter, index) => (
              <TableRow key={areaParameter.id}>
                <TableCell component="th" scope="row">
                  {index + 1}
                </TableCell>
                <TableCell align="left">
                  {areaParameter.parameter.name}
                </TableCell>
                <TableCell align="left">{areaParameter.importance}</TableCell>
                <TableCell align="left">
                  <IconButton
                    color="primary"
                    onClick={() => editParameter(areaParameter)}
                  >
                    <Edit />
                  </IconButton>
                  <IconButton
                    color="secondary"
                    onClick={() => deleteAreaParam(areaParameter)}
                  >
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
}

const mapDispatchToProps = (dispatch) => ({
  deleteAreaParam: (areaParam) => dispatch(deleteParameter(areaParam)),
});

export default connect(null, mapDispatchToProps)(AreaParameterTable);



// WEBPACK FOOTER //
// ./src/areaParameters/AreaParameterTable.js